import { IconWrapper } from '../runtime';
export default IconWrapper('equal-column-width', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M3.75 6.24899V1.90064C3.75 1.82885 3.67659 1.78045 3.61061 1.80873L2 2.49899M13 6.24899V1.90064C13 1.82885 12.9266 1.78045 12.8606 1.80873L11.25 2.49899M8 8.99899V13.999M3.25 14.249H12.75C13.5784 14.249 14.25 13.5774 14.25 12.749V10.249C14.25 9.42056 13.5784 8.74899 12.75 8.74899H3.25C2.42157 8.74899 1.75 9.42056 1.75 10.249V12.749C1.75 13.5774 2.42157 14.249 3.25 14.249Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.75 2.74976C8.75 3.16397 8.41421 3.49976 8 3.49976C7.58579 3.49976 7.25 3.16397 7.25 2.74976C7.25 2.33554 7.58579 1.99976 8 1.99976C8.41421 1.99976 8.75 2.33554 8.75 2.74976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.75 5.74976C8.75 6.16397 8.41421 6.49976 8 6.49976C7.58579 6.49976 7.25 6.16397 7.25 5.74976C7.25 5.33554 7.58579 4.99976 8 4.99976C8.41421 4.99976 8.75 5.33554 8.75 5.74976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});